import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserSettings } from '@paragon/contract-library';

type UserSettingsState = UserSettings | null;

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState: null as UserSettingsState,
  reducers: {
    applyUserSettings: (state, action: PayloadAction<UserSettings>) => action.payload,
  },
});

export const { applyUserSettings } = userSettingsSlice.actions;
export const userSettings = userSettingsSlice.reducer;
